import { render, staticRenderFns } from "./ActionOpenUrl.vue?vue&type=template&id=448a39a4&scoped=true&"
import script from "./ActionOpenUrl.vue?vue&type=script&lang=js&"
export * from "./ActionOpenUrl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448a39a4",
  null
  
)

export default component.exports